/**

*/

export default {
  // api: "https://pg.nsuk.edu.ng/api",
  api: "https://test.nsuk.edu.ng/api",
    // api: "https://ug.nsuk.edu.ng/api"
  // api: 'http://localhost:8081/api',
  // api: 'http://localhost:8080/api',
  // api: 'http://192.168.0.137:8080/api',
  //  api:  "https://pg.nsuk.edu.ng/api",
  // api: 'http://34.23.160.253/api'
};
